<template>
    <el-tooltip class="item" effect="dark" content="切换背景" placement="bottom-start">
        <el-switch v-model="isDark" class="change-theme-switch" @change="changeTheme">
        </el-switch>
    </el-tooltip>
</template>
<script>
import { mapActions, mapState } from 'vuex'
export default {
    name: 'ThemeSwitch',
    data() {
        return {
            themesName: 'defaultTheme',
            isDark: false,
            isDecode: true
        }
    },
    computed: {
        ...mapState({
            themeName: state => state.app.themeName
        })
    },
    watch: {
        themeName() {
            if (this.themeName == 'darkTheme') {
                this.isDark = true
            } else {
                this.isDark = false
            }
        }
    },
    mounted() {
        this.handleTheme()
    },
    methods: {
        handleTheme() {
            this.$apis.configmanage.getPersonConfig().then(res => {
                this.isDecode = res.data.txValueDecode
                // res.data.backGround == 'darkTheme'
                //   ? (this.themesName = 'darkTheme')
                //   : (this.themesName = 'defaultTheme')
                // localStorage.setItem('cbaas_system_theme', this.themesName)
                // this.$store.dispatch('updateTheme', this.themesName)
                // document.body.className = this.themesName
                const theme = res.data.backGround
                theme ? (this.themesName = theme) : (this.themesName = 'defaultTheme')
                this.themesName === 'darkTheme' ? (this.isDark = true) : (this.isDark = false)
                localStorage.setItem('cbaas_system_theme', this.themesName)
                this.$store.dispatch('updateTheme', this.themesName)
                document.body.className = this.themesName
            })
            // const theme = localStorage.getItem('cbaas_system_theme')
            // theme ? (this.themesName = theme) : (this.themesName = 'defaultTheme')
            // this.themeName === 'darkTheme' ? (this.isDark = true) : (this.isDark = false)
            // document.body.className = this.themesName
        },
        changeTheme(status) {
            let command = ''
            status ? (command = 'darkTheme') : (command = 'defaultTheme')
            this.themesName = command
            this.$apis.configmanage
                .setPersonConfig({
                    backGround: this.themesName,
                    txValueDecode: this.isDecode
                })
                .then(res => {
                    localStorage.setItem('cbaas_system_theme', this.themesName)
                    this.$store.dispatch('updateTheme', this.themesName)
                    document.body.className = this.themesName
                })
            // let command = ''
            // status ? (command = 'darkTheme') : (command = 'defaultTheme')
            // this.themesName = command
            // localStorage.setItem('cbaas_system_theme', command)
            // this.$store.dispatch('updateTheme', command)
            // document.body.className = this.themesName
        }
    }
}
</script>
<style scoped lang="scss">
.change-theme-switch {
    height: var(--navbar-theme-switch-height);
    width: var(--navbar-theme-switch-width);
    line-height: var(--navbar-theme-switch-height);

    /deep/ .el-switch__core {
        height: var(--navbar-theme-switch-height);
        width: var(--navbar-theme-switch-width) !important;
        background-color: var(--navbar-theme-switch-core-color);
        border-width: var(--navbar-theme-switch-border-width);
        border-color: var(--navbar-theme-switch-core-color);
        border-radius: calc(var(--navbar-theme-switch-height) / 2);

        &::after {
            width: var(--navbar-theme-switch-btn-size);
            height: var(--navbar-theme-switch-btn-size);
            top: var(--navbar-theme-switch-btn-offset);
            left: var(--navbar-theme-switch-btn-offset);
            background-color: var(--navbar-theme-switch-core-btn-color);
        }
    }
}

.change-theme-switch.is-checked {
    /deep/ .el-switch__core {
        background-color: var(--navbar-theme-switch-core-color);
        border-color: var(--navbar-theme-switch-core-color);
        
        &::after {
            margin-left: var(--navbar-theme-switch-btn-after-margin-left);
        }
    }
}
</style>